import Alert from '@storeblocks/alert';
import React from 'react';

import { Markdown } from 'Components/Markdown';
import { AgreementCode } from 'Constants/agreementCodes.constants';
import { isAkaAgreement } from 'Utils/agreementCodes/agreementCodes.utils';
import { LinkRenderer } from 'Utils/markdown.utils';
import { getAppText } from 'Utils/text';
import { getPartnerPhoneNumberVariable } from '../EmailCancellation/emailCancellationForm.helpers';

type HealthDeclarationAlertProps = {
  agreementProduct: AgreementCode;
};

export const HealthDeclarationAlert = ({
  agreementProduct,
}: HealthDeclarationAlertProps) => {
  const link = isAkaAgreement(agreementProduct)
    ? 'https://www.storebrand.no/akademikerne/flytte-personforsikringer#fra-storebrand'
    : 'https://www.storebrand.no/privat/forsikring/flytte-personforsikringer#fra-storebrand';

  const variables = {
    ...getPartnerPhoneNumberVariable(agreementProduct),
    moveInsuranceTermsHref: link,
  };
  return (
    <Alert title={getAppText('cancelInsurance.healthDeclarationAlert.title')}>
      <Markdown components={{ a: LinkRenderer }}>
        {getAppText('cancelInsurance.healthDeclarationAlert.content.markdown', {
          insert: variables,
        })}
      </Markdown>
    </Alert>
  );
};
